import { API_CLIENT_PERMISSIONS_READ, API_CURRENT_USER_PERMISSIONS_READ, API_PERMISSIONS_DICTIONARY, API_USER_PERMISSIONS_READ } from "../../../services/api/api.urls";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { api } from "../../../services/api/api.service";
import { toastr } from "react-redux-toastr";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { TryCatch } from "../../../services/TryCatch";

export interface IUserPermissionBody {
    id: number | undefined,
    codes: string[]
}

export interface IPermissionsDictionary {
    id: string
    name: string
}

interface IUserGroupState {
    permissions: IPermissionsDictionary[]
    tourTypes: IPermissionsDictionary[]
}


const initialState: IUserGroupState = {
    permissions: [],
    tourTypes: []
}


export const getPermissionsDictionary = createAsyncThunk<IPermissionsDictionary[], string, { rejectValue: string }>(
    'permission/get-permission',
    async (type, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_PERMISSIONS_DICTIONARY}?type=${type}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to fetch roles.')
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const getTourTypes = createAsyncThunk<IPermissionsDictionary[], void, { rejectValue: string }>(
    'permission/get-tour-types',
    async (_, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_PERMISSIONS_DICTIONARY}?type=competition"`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to fetch roles.')
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const readUserPermissions = createAsyncThunk<IUserPermissionBody, number, { rejectValue: string }>(
    'permission/read-user-permission',
    async (userId, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_USER_PERMISSIONS_READ}/${userId}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to fetch roles.')
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const readClientPermissions = createAsyncThunk<IUserPermissionBody, number, { rejectValue: string }>(
    'permission/read-user-permission',
    async (clientId, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_CLIENT_PERMISSIONS_READ}/${clientId}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to fetch roles.')
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)

export const getPermissionsForCurrentUser = createAsyncThunk<string[], string[], { rejectValue: string }>(
    'permission/get-perms-for-current-user',
    async (permissions, {rejectWithValue,dispatch}) => {
        const result = await TryCatch(
            () => api.post(`${API_CURRENT_USER_PERMISSIONS_READ}`, permissions).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, 'Failed to fetch roles.')
            return rejectWithValue(result.error);
        }
        //dispatch(setUserPermissions(result.data))
        return result.data;
    }
)

export const permissionsSlice = createSlice({
    name: 'userGroups',
    reducers: {},
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getPermissionsDictionary.fulfilled, (state: IUserGroupState, action) => {
                state.permissions = action.payload
            })
            .addCase(getTourTypes.fulfilled, (state: IUserGroupState, action) => {
                state.tourTypes = action.payload
            })
    },
});

export default permissionsSlice.reducer;